import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';
import { ESTADOS_SOLICITUD, PCT_REFERIDO, PUNTOS_REFERIDO, bodasApi, mensajeError } from '../bodasUtils';
import { Panel, Vacio } from './comunes';
import { FilaSolicitud, TarjetaSolicitud } from './FilasSolicitud';

const ORIGENES = [{ valor: '', etiqueta: 'Todos' }, { valor: 'boda', etiqueta: 'Invitados de boda' }, { valor: 'referido', etiqueta: 'Referidos' }];

export default function TablaSolicitudes({ gestiona }) {
  const [origen, setOrigen] = useState('');
  const [estado, setEstado] = useState('');
  const [solicitudes, setSolicitudes] = useState([]);
  const [cargando, setCargando] = useState(true);

  const cargar = useCallback(() => {
    setCargando(true);
    bodasApi.solicitudes(origen ? { origen } : {}).then(d => setSolicitudes(d.solicitudes))
      .catch(e => toast.error(mensajeError(e, 'No se pudieron cargar las solicitudes'))).finally(() => setCargando(false));
  }, [origen]);
  useEffect(() => { cargar(); }, [cargar]);

  const visibles = useMemo(() => solicitudes.filter(s => !estado || s.estado === estado), [solicitudes, estado]);
  const onEstado = async (id, nuevo) => {
    try { await bodasApi.estadoSolicitud(id, nuevo); setSolicitudes(prev => prev.map(s => s.id === id ? { ...s, estado: nuevo } : s)); toast.success('Estado actualizado'); }
    catch (e) { toast.error(mensajeError(e)); }
  };

  return (
    <Panel testId="solicitudes-panel">
      <div className="flex flex-col gap-3 border-b border-slate-100 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap gap-1.5">
          {ORIGENES.map(o => (
            <button key={o.valor} type="button" onClick={() => setOrigen(o.valor)} data-testid={`solicitudes-origen-${o.valor || 'todos'}`}
              className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${origen === o.valor ? 'bg-slate-800 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}>{o.etiqueta}</button>
          ))}
        </div>
        <select value={estado} onChange={e => setEstado(e.target.value)} className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm" data-testid="solicitudes-filtro-estado">
          <option value="">Todos los estados</option>
          {ESTADOS_SOLICITUD.map(e => <option key={e.valor} value={e.valor}>{e.etiqueta}</option>)}
        </select>
      </div>
      <p className="px-4 pt-3 text-xs text-slate-500">El {PCT_REFERIDO}% se carga solo en la primera cotización de cada persona (se reconoce por su correo o teléfono). Cuando compra, quien la refirió recibe {PUNTOS_REFERIDO} Puntos JPM. Quien ya es cliente con compras, se registra dos veces o usa su propio enlace queda como «No aplica».</p>
      {cargando && !solicitudes.length ? <Vacio>Cargando…</Vacio> : !visibles.length ? <Vacio testId="solicitudes-vacio">No hay registros con estos filtros.</Vacio> : (
        <>
          <ul className="divide-y divide-slate-100 md:hidden">{visibles.map(s => <TarjetaSolicitud key={s.id} s={s} gestiona={gestiona} onEstado={onEstado} />)}</ul>
          <div className="hidden overflow-x-auto md:block">
            <table className="w-full min-w-[860px] text-sm">
              <thead className="bg-slate-50 text-xs uppercase text-slate-500">
                <tr>{['Fecha', 'Persona', 'Viene de', 'Beneficio', 'Seguimiento', 'Estado'].map(h => <th key={h} className="px-4 py-3 text-left font-medium">{h}</th>)}</tr>
              </thead>
              <tbody className="divide-y divide-slate-100">{visibles.map(s => <FilaSolicitud key={s.id} s={s} gestiona={gestiona} onEstado={onEstado} />)}</tbody>
            </table>
          </div>
        </>
      )}
    </Panel>
  );
}
